/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";

type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const submitDummyReturnReceiptEvent = /* GraphQL */ `mutation SubmitDummyReturnReceiptEvent($rawEvent: String!) {
  submitDummyReturnReceiptEvent(rawEvent: $rawEvent) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitDummyReturnReceiptEventMutationVariables,
  APITypes.SubmitDummyReturnReceiptEventMutation
>;
export const requestBondedReturnUploadUrl = /* GraphQL */ `mutation RequestBondedReturnUploadUrl {
  requestBondedReturnUploadUrl {
    uploadUrl
    fileId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RequestBondedReturnUploadUrlMutationVariables,
  APITypes.RequestBondedReturnUploadUrlMutation
>;
export const triggerProcessBondedReturnFile = /* GraphQL */ `mutation TriggerProcessBondedReturnFile($fileId: String!) {
  triggerProcessBondedReturnFile(fileId: $fileId) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TriggerProcessBondedReturnFileMutationVariables,
  APITypes.TriggerProcessBondedReturnFileMutation
>;
